import React from 'react';
import { Grid, Skeleton, Box } from '@mui/material';

const ParticipatingLocationsSkeleton = () => (
  <Grid container spacing={2}>
    <Grid item lg={6} md={12} xs={12}>
      <Skeleton variant="text" height={50} width="60%" />
      <Skeleton variant="text" height={50} />
      {[...Array(2).keys()].map(() => (
        <Box my={2}>

          <Skeleton variant="text" height={40} width="200px" />
          <Skeleton variant="text" height={40} width="150px" />
          <Skeleton variant="text" height={40} width="90%" />

          <Grid container spacing={1}>
            <Grid item xs={3}>
              <Skeleton variant="text" height={40} />
            </Grid>
          </Grid>
        </Box>
      ))}
    </Grid>
    <Grid item lg={6} md={12} xs={12} minHeight="300px">
      <Skeleton variant="rectangular" height="100%" width="100%" />
    </Grid>
  </Grid>
);
export { ParticipatingLocationsSkeleton };